import styled from "styled-components";
import { media } from "../../../../utils";

export const SectionHeader = styled.div`
  background: #500778;
  padding: 86px 20px;

  ${media.md()} {
    padding: 60px 0;
  }
`;

export const ContentImage = styled.div`
  .ContentWithImage__Image {
    margin-top: -75px;

    ${media.md()} {
      margin-top: 0;
    }
  }
`;

export const WhiteContainer = styled.div`
  background-color: ${({ theme }) => theme.color.line.light};
  border-radius: 16px;
  padding: 24px 20px;

  ${media.md()} {
    padding: 24px 64px;
  }
`;

export const SorteiosTitle = styled.h2`
  color: ${({ theme }) => theme.color.brandPrimary.light};
  font-weight: 700;
`;
